
<div style="overflow-y:auto; height: 100%; padding-right: 24px; overflow-x:hidden;">
  <div nz-row [nzGutter]="['12','0']">
    <nz-divider nzText="Thông tin cá nhân" nzOrientation="left" nzPlain ></nz-divider>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Mã nhân sự</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input formControlName="name" name="email" type="email" id="email" [jAutofocus]>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Mã nhân sự SGD</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Mã nhân sự BGD</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Họ đệm</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Tên</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Giới tính</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-radio-group>
            <label nz-radio nzValue="tatCa">Tất cả</label>
            <label nz-radio nzValue="nam">Nam</label>
            <label nz-radio nzValue="nu">Nữ</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Ngày sinh</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-date-picker [nzFormat]="'dd/MM/yyyy'"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Nơi sinh</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8"></div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Dân tộc</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Tôn giáo</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Không"></nz-option>
            <nz-option nzValue="2" nzLabel="Công giáo"></nz-option>
            <nz-option nzValue="3" nzLabel="Phật giáo"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Quốc tịch</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Việt Nam"></nz-option>
            <nz-option nzValue="2" nzLabel="Pháp"></nz-option>
            <nz-option nzValue="3" nzLabel="Mỹ"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Tiếng dân tộc</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Ngày chuyển đến</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-date-picker [nzFormat]="'dd/MM/yyyy'"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Ngày tuyển dụng</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Phòng ban</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Phòng giáo viên"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Trạng thái CB</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Đang làm việc"></nz-option>
            <nz-option nzValue="2" nzLabel="Đi học"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Số thứ tự</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-input-number [nzMin]="0" [nzMax]="1000" [nzStep]="1"></nz-input-number>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div class="tab-inside">
    <nz-tabset nzType="card">
      <nz-tab [nzTitle]="'Thông tin giảng dạy'">
        <div nz-row nzGutter="24">
          <nz-divider nzText="Thông tin giảng dạy" nzOrientation="left" nzPlain ></nz-divider>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Loại nhân sự</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Giáo viên"></nz-option>
                    <nz-option nzValue="2" nzLabel="Chuyên viên"></nz-option>
                    <nz-option nzValue="3" nzLabel="Cán bộ quản lý"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Chức vụ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Tổ trưởng chuyên môn"></nz-option>
                    <nz-option nzValue="2" nzLabel="Tổ phó chuyên môn"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">KQBD thường xuyên</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Tốt"></nz-option>
                    <nz-option nzValue="2" nzLabel="Khá"></nz-option>
                    <nz-option nzValue="3" nzLabel="Đạt"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="24">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">GD cấp học</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Mẫu giáo"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">GV GD văn hóa</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn" nzDisabled="true">
                    <nz-option nzValue="1" nzLabel="Tốt"></nz-option>
                    <nz-option nzValue="2" nzLabel="Khá"></nz-option>
                    <nz-option nzValue="3" nzLabel="Đạt"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="16">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Nhiệm vụ kiêm nhiệm</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Môn dạy giáo viên</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Môn dạy kiêm nhiệm</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Phụ trách cấp học</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Mẫu giáo"></nz-option>
                    <nz-option nzValue="2" nzLabel="Tiểu học"></nz-option>
                    <nz-option nzValue="3" nzLabel="THCS"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Số buổi dạy/ngày</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="1 buổi/ngày"></nz-option>
                    <nz-option nzValue="2" nzLabel="2 buổi/ngày"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Số tiết thực dạy/tuần</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-input-number [nzMin]="0" [nzMax]="1000" [nzStep]="1"></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Số tiết thực KN/tuần</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-input-number [nzMin]="0" [nzMax]="1000" [nzStep]="1"></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>
            <nz-divider></nz-divider>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzFor="maHS">Không đồng bộ N.sự</nz-form-label>
                <nz-form-control>
                  <label nz-checkbox></label>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="16">
    
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Trình độ chuyên môn</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Tiến sĩ"></nz-option>
                    <nz-option nzValue="2" nzLabel="Thạc sĩ"></nz-option>
                    <nz-option nzValue="3" nzLabel="Đại Học"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Chuyên ngành</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Khác"></nz-option>
                    <nz-option nzValue="2" nzLabel="Giáo dục chính trị"></nz-option>
                    <nz-option nzValue="3" nzLabel="Giáo dục mầm non"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Trình độ chính</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Trung cấp"></nz-option>
                    <nz-option nzValue="2" nzLabel="Cao đẳng"></nz-option>
                    <nz-option nzValue="3" nzLabel="Đại học"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Ngạch</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Tiến sĩ"></nz-option>
                    <nz-option nzValue="2" nzLabel="Cán bộ"></nz-option>
                    <nz-option nzValue="3" nzLabel="Chuyên viên"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Bậc</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn" nzDisabled="true">
                    <nz-option nzValue="1" nzLabel="Khác"></nz-option>
                    <nz-option nzValue="2" nzLabel="Giáo dục chính trị"></nz-option>
                    <nz-option nzValue="3" nzLabel="Giáo dục mầm non"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Hệ số lương</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-input-number [nzMin]="0" [nzMax]="1000" [nzStep]="1"></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Mã số(mã ngạch)</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Loại hợp đồng</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Hợp động lao động từ 1 năm trở xuống"></nz-option>
                    <nz-option nzValue="2" nzLabel="Hợp đồng lao động trên một năm"></nz-option>
                    <nz-option nzValue="3" nzLabel="Thỉnh giảng"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Mức P.cấp Ư.đãi nghề</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-input-number [nzMin]="0" [nzMax]="1000" [nzStep]="1" nzPlaceHolder="%"></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Số CMND</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Ngày cấp CMND</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-date-picker [nzFormat]="'dd/MM/yyyy'"></nz-date-picker>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Nơi cấp CMND</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item>
            </div>
        </div>
      </nz-tab>
      <nz-tab [nzTitle]="'Thông tin liên hệ'">
        <div nz-row nzGutter="24">
          <nz-divider nzText="Thông tin liên hệ" nzOrientation="left" nzPlain ></nz-divider>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Địa chỉ thường trú</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Địa chỉ hiện tại</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Tỉnh thành</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Hợp động lao động từ 1 năm trở xuống"></nz-option>
                    <nz-option nzValue="2" nzLabel="Hợp đồng lao động trên một năm"></nz-option>
                    <nz-option nzValue="3" nzLabel="Thỉnh giảng"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Quận huyện</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Hợp động lao động từ 1 năm trở xuống"></nz-option>
                    <nz-option nzValue="2" nzLabel="Hợp đồng lao động trên một năm"></nz-option>
                    <nz-option nzValue="3" nzLabel="Thỉnh giảng"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Phường xã</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Hợp động lao động từ 1 năm trở xuống"></nz-option>
                    <nz-option nzValue="2" nzLabel="Hợp đồng lao động trên một năm"></nz-option>
                    <nz-option nzValue="3" nzLabel="Thỉnh giảng"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Thôn xóm</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Điện thoại CQ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Điện thoại NR</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Điện thoại DĐ</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Email</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Mã CCVC</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Ghi chú</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Hôn nhân</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Hợp động lao động từ 1 năm trở xuống"></nz-option>
                    <nz-option nzValue="2" nzLabel="Hợp đồng lao động trên một năm"></nz-option>
                    <nz-option nzValue="3" nzLabel="Thỉnh giảng"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Nhóm máu</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Hợp động lao động từ 1 năm trở xuống"></nz-option>
                    <nz-option nzValue="2" nzLabel="Hợp đồng lao động trên một năm"></nz-option>
                    <nz-option nzValue="3" nzLabel="Thỉnh giảng"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Tình trạng sức khỏe</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Hợp động lao động từ 1 năm trở xuống"></nz-option>
                    <nz-option nzValue="2" nzLabel="Hợp đồng lao động trên một năm"></nz-option>
                    <nz-option nzValue="3" nzLabel="Thỉnh giảng"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">TP xuất thân</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Hợp động lao động từ 1 năm trở xuống"></nz-option>
                    <nz-option nzValue="2" nzLabel="Hợp đồng lao động trên một năm"></nz-option>
                    <nz-option nzValue="3" nzLabel="Thỉnh giảng"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Diện ƯT gia đình</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Hợp động lao động từ 1 năm trở xuống"></nz-option>
                    <nz-option nzValue="2" nzLabel="Hợp đồng lao động trên một năm"></nz-option>
                    <nz-option nzValue="3" nzLabel="Thỉnh giảng"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Diện ƯT bản thân</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
                    <nz-option nzValue="1" nzLabel="Hợp động lao động từ 1 năm trở xuống"></nz-option>
                    <nz-option nzValue="2" nzLabel="Hợp đồng lao động trên một năm"></nz-option>
                    <nz-option nzValue="3" nzLabel="Thỉnh giảng"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Năm vào ngành</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-date-picker nzFormat="year"></nz-date-picker>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Ngày vào trường</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-date-picker [nzFormat]="'dd/MM/yyyy'"></nz-date-picker>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Năng khiếu/ST</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Số sổ BHXH</nz-form-label>
                <nz-form-control nzSpan="24">
                  <input nz-input name="email" type="email" id="email">
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Ngày B.đầu BHXH</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-date-picker [nzFormat]="'dd/MM/yyyy'"></nz-date-picker>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="8">
              <nz-form-item>
                <nz-form-label nzSpan="24" nzFor="maHS">Số người GTGC</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-input-number [nzMin]="0" [nzMax]="1000" [nzStep]="1"></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
      </nz-tab>
      <nz-tab [nzTitle]="'Thông tin khác'">
        <div nz-row nzGutter="24">
          <nz-divider nzText="Thông tin liên hệ" nzOrientation="left" nzPlain ></nz-divider>
          <div nz-col nzSm="24" nzMd="8">
            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox>Đảng viên</label>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSm="24" nzMd="8">
            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox>Đoàn viên</label>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSm="24" nzMd="8">
            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox>Tổng phụ trách đội</label>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSm="24" nzMd="8">
            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox>Là tuyển mới</label>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSm="24" nzMd="8">
            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox>Biên chế</label>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSm="24" nzMd="8">
            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox>Dạy học sinh khuyết tật hòa nhập</label>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSm="24" nzMd="8">
            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox>Tham gia chương trình bồi dưỡng thường xuyên</label>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSm="24" nzMd="8">
            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox>Có chứng chỉ bồ dưỡng TCCD</label>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSm="24" nzMd="8">
            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox>Đã tập huấn kỹ năng sống HIV,SKSS</label>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSm="24" nzMd="8">
            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox>Có số hưu</label>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>    
      </nz-tab>
    </nz-tabset>
  </div>

</div>
